//APP.JS
/***********************************IMPORT LIBRARIES*************************************************** */
import React, { useEffect, useState } from 'react';
import { Route, Switch, Redirect, useHistory } from 'react-router-dom';
import { LastLocationProvider } from 'react-router-last-location';
import Cookies from 'js-cookie';
import { NotificationContainer } from 'react-notifications';
import SessionManagerContextProvider from './context/sessionManagerContext/sessionManagerContext';
import Echo from 'laravel-echo';
import io from 'socket.io-client';

/*************************************ROUTE COMPONENTS****************************************** */
import Login from './components/login/Login';
import Home from './components/home/Home';
import Register from './components/register/Register';
import ForgotPassword from './components/forgot_password/ForgotPassword';
import ResendConfirmEmail from './components/resend_confirm_email/ResendConfirmEmail';
import NotFound from './components/error_page/404';
import ChangePassword from './components/change_password/ChangePassword';
import FinishRegistration from './components/confirm_registration/FinishRegistration';
import RecoveryPassword from './components/forgot_password/RecoveryPassword';
import EditProfile from './components/edit_profile/EditProfile';
import BoostrapTable from './components/helpers_components/BootstrapTable';
import Formalities from './components/formalities/Formalities';
import Procedure from './components/formalities/Procedure';
import RequestOffline from './components/request_offline/RequestOffline';
import NotificationOffline from './components/request_offline/NotificationOffline';
import ProcessList from './components/formalities/ProcessList';
import AlertNotificationTable from './components/alert_notification_table/AlertNotificationTable';
import RenderForms from './components/formalities/star_procedure/RenderForms';
import AvatarConfig from './components/avatar_config/AvatarConfig';
import ConfirmationEmail from './components/confirmation_email/ConfirmationEmail';
import ErrorPage from './components/helpers_components/ErrorPage';
import NotificationListContext from './components/alert_notification_table/notification_context';
import ProcedureList from './components/procedure_list/ProcedureList';
import LoaderContext from './components/layout/shared/loader_context';
import ErrorCatcher from './components/error_page/500';
import FloatContactButton from './components/buttons/floatContactButton/FloatContactButton';
import GlobalModal from './components/modals/GlobalModal';
import SearchLawyers from './components/search_for_lawyers/SearchLawyers';
import PublicMovements from './components/search_to_citizens/PublicMovements';
import ExpedientDetails from './components/governement_book/expedient_details/ExpedientDetails';
import ExpedientsList from './components/governement_book/my_expedients/ExpedientsList';
import InsertPromotions from './components/governement_book/insert_to_expedient/InsertPromotions';
import NotificationReceived from './components/governement_book/notification/NotificationReceived';
import ExpedientNotificationProvider from './components/modals/expedientNotificationModal/context/ExpedientNotificationContext';
import ExpedientNotificationModal from './components/modals/expedientNotificationModal/ExpedientNotificationModal';
import ExpedientConsultation from './components/onlineJudgmentBridge/pages/expedientConsultation/ExpedientConsultation';
import ChangeEmail from './components/change_email/ChangeEmail';
import DocumentValidator from './components/onlineJudgmentBridge/pages/DocumentsValidator/DocumentValidator';

const App = (props) => {
  const history = useHistory();

  const [countNotifications, setCountNotifications] = useState(0);
  const [needUpdateCount, setNeedUpdateCount] = useState(false);
  const [statusLoader, setLoaderStatus] = useState(false);
  const [dispatch, setDispatch] = useState(true);
  const [showGlobalModal, setShowGlobalModal] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [logoutNotification, setLogoutNotification] = useState(false);

  const updateCountHandler = (state, sumOrSubtract, newCountAlerts) => {
    //THIS FUNCTION ALLOWS CHANGE THE STATE WHEN THE CHECKBOX MARK AS READ AND RENDER THE COMPONENT FOR THE COUNTER ALERT UPDATE
    if (sumOrSubtract === 'subtract') {
      setCountNotifications(countNotifications - 1);
    } else if (sumOrSubtract === 'sum') {
      setCountNotifications(newCountAlerts);
    }
    setNeedUpdateCount(state);
  };

  useEffect(() => {
    if (dispatch) {
      socketComunication();
      setDispatch(false);
    }
  }, []);

  useEffect(() => {
    if (logoutNotification) {
      setShowGlobalModal(true);
    }
  }, [logoutNotification]);

  useEffect(() => {
    let interval = null;
    let timeout = null;

    if (showGlobalModal) {
      setCountdown(5);

      interval = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);

      timeout = setTimeout(() => {
        setShowGlobalModal(false);
        Cookies.remove('authentication_token_02');
        Cookies.remove('isAuth_02');
        history.push('/');
      }, 5000);
    }

    return () => {
      if (interval) clearInterval(interval);
      if (timeout) clearTimeout(timeout);
    };
  }, [showGlobalModal, history]);

  const socketComunication = () => {
    const token = Cookies.get('authentication_token_02');

    if (token) {
      const echo = new Echo({
        broadcaster: 'socket.io',
        host: process.env.REACT_APP_SERVER_WEB_SOCKET,
        transports: ['websocket'],
        auth: {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
        client: io,
      });

      echo.connector.socket.on('connect', () => {});

      echo.connector.socket.on('disconnect', () => {});

      echo.connector.socket.on('error', (error) => {
        console.error('WebSocket error:', error);
      });

      const closeSessionsChannel = echo.channel('close-sessions');

      closeSessionsChannel
        .subscribed(() => {})
        .listen('.closeSessions', (notification) => {
          setLogoutNotification(notification);
        })
        .error((error) => {
          console.error('Error subscribing to close-sessions channel:', error);
        })
        .on('error', (error) => {
          console.error('Socket communication error:', error);
        });
    }
  };

  return (
    <ErrorCatcher>
      <FloatContactButton />
      <NotificationListContext.Provider
        value={{
          count: countNotifications,
          updateCount: updateCountHandler,
          requireUpdate: needUpdateCount,
        }}
      >
        <LoaderContext.Provider
          value={{
            status: statusLoader,
            show: (status) => {
              setLoaderStatus(status);
            },
          }}
        >
          <ExpedientNotificationProvider>
            {showGlobalModal && <GlobalModal visible={showGlobalModal} countdown={countdown} />}
            <NotificationContainer />
            <LastLocationProvider>
              <SessionManagerContextProvider>
                <Switch>
                  <Route exact path="/confirmation_email:token?" component={ConfirmationEmail} />
                  <Route exact path="/request_offline" component={RequestOffline} />
                  <Route
                    exact
                    path="/"
                    render={(props) =>
                      Cookies.get('isAuth_02') ? <Home {...props} /> : <Login {...props} />
                    }
                  />
                  <Route
                    path="/home"
                    render={(props) =>
                      Cookies.get('isAuth_02') ? <Home {...props} /> : <Redirect to={'/'} />
                    }
                  />
                  <Route path="/products" component={BoostrapTable} />

                  <Route
                    path="/procedure-list"
                    render={(props) =>
                      Cookies.get('isAuth_02') ? (
                        <ProcedureList history={props.history} />
                      ) : (
                        <Redirect to="/" />
                      )
                    }
                  />
                  <Route
                    path="/change-password"
                    render={(props) =>
                      Cookies.get('isAuth_02') ? (
                        <ChangePassword history={props.history} />
                      ) : (
                        <Redirect to="/" />
                      )
                    }
                  />
                  <Route
                    path="/change-email"
                    render={(props) =>
                      Cookies.get('isAuth_02') ? (
                        <ChangeEmail history={props.history} />
                      ) : (
                        <Redirect to="/" />
                      )
                    }
                  />
                  <Route
                    path="/edit-profile"
                    render={(props) =>
                      Cookies.get('isAuth_02') ? (
                        <EditProfile history={props.history} />
                      ) : (
                        <Redirect to="/" />
                      )
                    }
                  />
                  <Route
                    path="/alert-notifications"
                    render={(props) =>
                      Cookies.get('isAuth_02') ? (
                        <AlertNotificationTable history={props.history} />
                      ) : (
                        <Redirect to="/" />
                      )
                    }
                  />
                  <Route
                    path="/formalities"
                    render={(props) =>
                      Cookies.get('isAuth_02') ? (
                        <Formalities history={props.history} />
                      ) : (
                        <Redirect to="/" />
                      )
                    }
                  />
                  <Route
                    path="/render_form"
                    render={(props) =>
                      Cookies.get('isAuth_02') ? (
                        <RenderForms history={props.history} />
                      ) : (
                        <Redirect to="/" />
                      )
                    }
                  />

                  <Route
                    path="/error_page"
                    render={(props) =>
                      Cookies.get('isAuth_02') ? <ErrorPage {...props} /> : <Redirect to="/" />
                    }
                  />

                  <Route
                    path="/getProcess"
                    render={(props) =>
                      Cookies.get('isAuth_02') ? (
                        <ProcessList history={props.history} />
                      ) : (
                        <Redirect to="/" />
                      )
                    }
                  />
                  <Route path="/resend-confirm-email" component={ResendConfirmEmail} />
                  <Route path="/forgot-password" component={ForgotPassword} />
                  <Route
                    render={(props) =>
                      props.location.state ? (
                        <NotificationOffline location={props.location} />
                      ) : (
                        <NotFound />
                      )
                    }
                    path="/notification_offline"
                  />
                  <Route
                    path="/recover_password:reset_password_token?"
                    component={RecoveryPassword}
                  />
                  <Route path="/register" component={Register} />
                  <Route path="/finish_registration:token?:reg?" component={FinishRegistration} />

                  <Route
                    path="/procedure/:id"
                    render={(props) =>
                      Cookies.get('isAuth_02') ? <Procedure props={props} /> : <Redirect to="/" />
                    }
                  />

                  <Route
                    path="/expedient_details/:expedient"
                    render={(props) => {
                      if (Cookies.get('isAuth_02')) {
                        if (Cookies.get('citizen_unauthorized')) {
                          Cookies.remove('citizen_unauthorized');
                          return <Redirect to="/my-expedients" />;
                        }
                        return <ExpedientDetails {...props} />;
                      }
                      return <Redirect to="/" />;
                    }}
                  />

                  <Route
                    path="/my-expedients"
                    render={(props) =>
                      Cookies.get('isAuth_02') ? <ExpedientsList {...props} /> : <Redirect to="/" />
                    }
                  />

                  <Route
                    path="/avatar_config"
                    render={(props) =>
                      Cookies.get('isAuth_02') ? (
                        <AvatarConfig history={props.history} />
                      ) : (
                        <Redirect to="/" />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/expedientes/buscar"
                    render={(props) => <SearchLawyers {...props} />}
                  />
                  <Route
                    exact
                    path="/boletin_judicial/consultar"
                    render={(props) => <PublicMovements {...props} />}
                  />
                  <Route
                    exact
                    path="/expedientes/insertar"
                    render={(props) => <InsertPromotions {...props} />}
                  />
                  <Route
                    exact
                    path="/notificacion/leer/:notification_id"
                    render={(props) =>
                      Cookies.get('isAuth_02') ? (
                        <NotificationReceived {...props} />
                      ) : (
                        <Redirect to="/" />
                      )
                    }
                  />

                  <Route
                    path="/consulta/expediente/:accessToken"
                    render={(props) => <ExpedientConsultation {...props} />}
                    exact
                  />

                  <Route
                    path="/document/validator/:token"
                    render={(props) => <DocumentValidator {...props} />}
                    exact
                  />

                  <Route component={NotFound} />
                </Switch>
                <ExpedientNotificationModal />
              </SessionManagerContextProvider>
            </LastLocationProvider>
          </ExpedientNotificationProvider>
        </LoaderContext.Provider>
      </NotificationListContext.Provider>
    </ErrorCatcher>
  );
};

export default App;
